import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface ReportKtxhs {
  name: string;
  api_token: string;
}

export interface ReportKtxhsListInfor {
  errors: unknown;
  reportKtxhs: ReportKtxhs;
  isAuthenticated: boolean;
}

@Module
export default class ReportKtxhsModule
  extends VuexModule
  implements ReportKtxhsListInfor
{
  errors = {};
  reportKtxhs = {} as ReportKtxhs;
  isAuthenticated = !!JwtService.getToken();

  get ReportKtxhs() {
    return this.reportKtxhsListData;
  }

  @Mutation
  [Mutations.REPORT_KTXHS_LIST_DATA](ReportKtxhs) {
    this.reportKtxhsListData = ReportKtxhs;
  }

  @Action
  [Actions.REPORT_KTXHS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/report_ktxh", payload)
        .then((data) => {
          this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.REPORT_KTXH_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("report_ktxh/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.REPORT_KTXH_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/report_ktxh", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.REPORT_KTXH_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/report_ktxh",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.REPORT_KTXHT_UPDATE_STATUS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/report_ktxh/${payload.id}/update-status`,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
